import React from "react";
import { useState,useEffect } from "react";
import { isMobile } from "react-device-detect";
import icon_gift from '../../icons/gift.jpg';
import icon_email from '../../icons/email.webp';
import icon_share from '../../icons/share.webp';
import Popup from "reactjs-popup";
import { defaultTheme } from '../../greeting-cards/themes/index';
import { GreetingCard,CardEditor, themes } from '../../greeting-cards';
import { useFetch } from "../../api/FetchApiData";
import { CardExpiryElement } from "@stripe/react-stripe-js";
if (isMobile)
    import('./gifts_mob.css').then(() => {});
else
    import('./gifts.css').then(() => {});


export default function Gifts()
{
    const fetchData = useFetch();
    const [gifts, setGifts] = useState([]);
    const [cards,setCards] = useState([]);
    const content = {
            'title': "Cadeau",
            'message': "Cadeau spécial pour une personne spéciale",
            'occasion': "chrismas",
            'value': 150,
            'date': "12/4/2026",
            'is_anonymous': false,
            'owner_is_editable': true,
            'from': 'Cheha MOHAMED',
            'to': '',

    }

    useEffect(()=>{
        fetchData.GetData('user/gifts/').then((result)=>{
            if(result.result)
            {setGifts(result.gifts);setCards(result.cards);}
        })
    },[])
    
    return(<div id="gifts">
                {cards.map((card)=>{
                    return(
                    <div className="gift">
                        <GreetingCard showDate={true} content={card.content} theme={(!!card.theme)?card.theme:defaultTheme} size={isMobile?"sm":"md"} showDate />
                    </div>)})}

            { /*
            <label className="gift-number">NUMERO CADEAUX</label>
            <label className="gift-sold">100000 KMF</label>
            <div className="gift-control" style={{background:'white'}}>
                <img src={icon_email} style={{width:'30px'}} />
                {<Share />
            </div>*/}  
    </div>);
}